// @ts-check
/* istanbul ignore file */
import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import InsightsEmptyStateImg from './images/insights-empty-state.svg';
import InsightsEmptyValuesImg from './images/insights-empty-values.svg';
import Icon from 'components/base/Icon';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';

export const INSIGHTS_EMPTY_STATES_TYPES = {
  NO_INSIGHTS: 'NO_INSIGHTS',
  NO_VALUES: 'NO_VALUES'
};

const mapEmptyStateTypeToImg = {
  [INSIGHTS_EMPTY_STATES_TYPES.NO_INSIGHTS]: InsightsEmptyStateImg,
  [INSIGHTS_EMPTY_STATES_TYPES.NO_VALUES]: InsightsEmptyValuesImg
};

const EmptyState = ({ type }) => {
  const history = useHistory();

  const goToInsightsConfig = () =>
    history.replace(
      AppRouter.PROJECTS_PROJECT_PROGRESSION_INSIGHTS_CONFIG.path
    );

  return (
    <Flex
      direction='column'
      width='99%'
      height='99%'
      items='center'
      justify='center'
    >
      <img src={mapEmptyStateTypeToImg[type]} alt='' />

      {type === INSIGHTS_EMPTY_STATES_TYPES.NO_VALUES && (
        <>
          <Text
            weight='400'
            size='large'
            pt={SPACES.normal}
            pb={SPACES['x-small']}
            color='shuttleGray'
          >
            No Insights to present
          </Text>
        </>
      )}
      {type === INSIGHTS_EMPTY_STATES_TYPES.NO_INSIGHTS && (
        <>
          <div style={{ marginTop: '2rem' }}>
            <LBButton variant='outline' onClick={goToInsightsConfig}>
              <Icon
                name='Settings'
                size='x-small'
                color='shuttleGray'
                style={{ marginRight: '0.5rem' }}
              />
              Set up insights
            </LBButton>
          </div>
        </>
      )}
    </Flex>
  );
};

export default EmptyState;
